// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-n_fx","galleryItem_borderTopRadius":"c-n_fy","galleryItem__image":"c-n_fz"};